// Room page badges: 3 quotable phrases picked by AI from real guest reviews, in the visitor's language.
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Quote } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const LABEL = { en: 'Guests say', me: 'Gosti kažu', sq: 'Mysafirët thonë', de: 'Gäste sagen', ru: 'Гости говорят', pl: 'Goście mówią', hu: 'Vendégeink mondják' };
const cache = {};

const ReviewHighlights = () => {
  const { lang } = useLanguage();
  const [items, setItems] = useState(cache[lang] || null);
  useEffect(() => {
    let alive = true;
    if (cache[lang]) { setItems(cache[lang]); return undefined; }
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/review-highlights?lang=${lang}`).then((r) => r.json()).then((d) => { cache[lang] = d.items || []; if (alive) setItems(cache[lang]); }).catch(() => alive && setItems([]));
    return () => { alive = false; };
  }, [lang]);
  if (!items?.length) return null;
  const prefix = lang === 'en' ? '' : `/${lang}`;
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="review-highlights">
      <span className="text-[11px] uppercase tracking-wider font-semibold text-gray-500 mr-1">{LABEL[lang] || LABEL.en}</span>
      {items.map((h, i) => (
        <Link key={i} to={`${prefix}/reviews`} className="group inline-flex items-center gap-1.5 bg-orange-50 border border-orange-200 text-orange-900 rounded-full pl-2.5 pr-3 py-1 text-sm hover:bg-orange-100 transition-colors" title={h.name ? `— ${h.name}${h.source ? `, ${h.source}` : ''}` : undefined} data-testid={`review-highlight-${i}`}>
          <Quote size={12} className="text-orange-400 group-hover:text-orange-600" />
          <span className="italic">{h.text}</span>
          {h.name && <span className="text-[11px] text-orange-700/70 not-italic hidden sm:inline">— {h.name.split(' ')[0]}</span>}
        </Link>
      ))}
    </div>
  );
};

export default ReviewHighlights;
